import React, { FC } from "react";
import { Button } from "../forms";
import { ModalPropsDTO } from "../../typings/generic";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
 
const Wizardbg = (props:any) => {

    const {setShowwiz}=useStateSetter()
 
  return (
    <>
      <div className="tooltipbg  ">
{props.active=="wizard" &&
        <div className="w-[30%] rounded-[8px] bg-white p-8">

<div className="h-[140px] bg-gray-200 mb-2  ">
  

</div>
<div>
        <p className="font-bold text-lg p-2 ">Welcome to RWND Engage</p>
        <p className="font-light text-xs">
        RWND Engage is an ERP system that helps you digitally manage your company or business. Take a few moments to learn the basics.
        </p>

        <div className=" flex justify-center  cust items-center w-full gap-6">
                      <Button
                        style={
                          "   bg-white !border-[#aaaaaa] border !text-textbg"
                        }
                        text="Maybe Later"
                        onBtnClick={props.skip}
                      />

                      <Button
                        text="Show me around"
                        onBtnClick={() => {
                     props.control("home")
                        }}
                      />
                    </div>
    </div>
        </div>}
      </div>
    </>
  );
};

export default Wizardbg;
